import React from "react";
import { Badge, Row, Col } from "react-bootstrap";
import { CommonModal } from "../Input";
import DataTable from "../table/DataTable";

// Import images
import bill1000 from "../../../images/cash/100_dollar.png"; // Reusing for 1000
import bill100 from "../../../images/cash/100_dollar.png";
import bill50 from "../../../images/cash/50_dollar.png";
import bill10 from "../../../images/cash/10_dollar.png";
import bill5 from "../../../images/cash/5_dollar.png";
import bill2 from "../../../images/cash/1_dollar.png"; // Reusing for 2
import bill1 from "../../../images/cash/1_dollar.png";

const RequestInformationModal = ({ show, onHide, request }) => {
  if (!request) return null;

  const summaryData = [
    { label: "Drawer ID", value: "Hanh Nguyen" },
    { label: "Created Date", value: `${request.displayDate} ${request.time}` },
    { label: "Created By", value: "teller" },
    { label: "Type", value: request.type },
    { label: "Status", value: request.status },
    { label: "Currency", value: "Singapore Dollar (SGD)" },
  ];

  const denominations = [
    {
      id: "bill1000",
      label: "1000 Dollars",
      value: 1000,
      inventory: 101,
      qty: 2,
      image: bill1000,
    },
    {
      id: "bill100",
      label: "100 Dollars",
      value: 100,
      inventory: 99,
      qty: 0,
      image: bill100,
    },
    {
      id: "bill50",
      label: "50 Dollars",
      value: 50,
      inventory: 9,
      qty: 0,
      image: bill50,
    },
    {
      id: "bill10",
      label: "10 Dollars",
      value: 10,
      inventory: 1,
      qty: 0,
      image: bill10,
    },
    {
      id: "bill5",
      label: "5 Dollars",
      value: 5,
      inventory: 1,
      qty: 0,
      image: bill5,
    },
    {
      id: "bill2",
      label: "2 Dollars",
      value: 2,
      inventory: 2,
      qty: 0,
      image: bill2,
    },
    {
      id: "bill1",
      label: "1 Dollar",
      value: 1,
      inventory: 50,
      qty: 0,
      image: bill1,
    },
    { id: "coin50c", label: "50 Cents", value: 0.5, inventory: "-", qty: 0 },
    { id: "coin20c", label: "20 Cents", value: 0.2, inventory: "-", qty: 0 },
    { id: "coin10c", label: "10 Cents", value: 0.1, inventory: "-", qty: 0 },
    { id: "coin5c", label: "5 Cents", value: 0.05, inventory: "-", qty: 0 },
  ];

  const columns = [
    {
      label: "IMAGE",
      key: "image",
      className: "ps-4 text-center",
      cellClassName: "ps-4 text-center",
      style: { width: "100px" },
      render: (item) => (
        <div
          className="d-flex align-items-center justify-content-center border rounded bg-white overflow-hidden mx-auto"
          style={{ width: "45px", height: "30px", borderColor: "#eee" }}
        >
          {item.image ? (
            <img
              src={item.image}
              alt={item.label}
              style={{ width: "100%", height: "auto" }}
            />
          ) : (
            <div className="text-muted fs-8 fw-bold">$</div>
          )}
        </div>
      ),
    },
    {
      label: "DENOMINATION",
      key: "label",
      style: { width: "250px" },
      render: (item) => (
        <span className="fs-13 fw-bold text-black">{item.label}</span>
      ),
    },
    {
      label: "INVENTORY",
      key: "inventory",
      className: "text-center",
      cellClassName: "text-center",
      style: { width: "150px" },
      render: (item) => (
        <div className="d-flex align-items-center justify-content-center">
          {item.inventory !== "-" && (
            <div
              className="rounded-circle me-1"
              style={{
                width: "8px",
                height: "8px",
                backgroundColor: "#34D399",
              }}
            />
          )}
          <Badge
            bg="light"
            className="text-black fw-bold px-3 py-1 border rounded-pill"
            style={{ fontSize: "11px", backgroundColor: "#F9FAFB" }}
          >
            {item.inventory}
          </Badge>
        </div>
      ),
    },
    {
      label: "QUANTITY",
      key: "quantity",
      className: "text-center",
      cellClassName: "text-center",
      style: { width: "200px" },
      render: (item) => (
        <div className="d-flex justify-content-center">
          <div
            className="form-control text-center py-1 d-flex align-items-center justify-content-center"
            style={{
              height: "36px",
              width: "100px",
              fontSize: "13px",
              borderColor: "#E2E8F0",
              borderRadius: "8px",
              backgroundColor: "#fff",
            }}
          >
            {item.qty}
          </div>
        </div>
      ),
    },
    {
      label: "TOTAL",
      key: "total",
      className: "pe-4 text-end",
      cellClassName: "pe-4 text-end",
      style: { width: "180px" },
      render: (item) => (
        <div className="fw-bold fs-13 text-black">
          SGD{" "}
          {(item.value * item.qty).toLocaleString(undefined, {
            minimumFractionDigits: 2,
          })}
        </div>
      ),
    },
  ];

  return (
    <CommonModal
      show={show}
      onHide={onHide}
      title="Request Information"
      fullscreen={true}
      headerClassName="px-4 py-3"
    >
      <div className="px-4 pt-3">
        <label className="text-black fw-bold fs-12 mb-3">
          Request Information
        </label>
        <div className="bg-white rounded-4 shadow-none p-4 mb-4 border border-light">
          <Row className="g-3">
            {summaryData.map((item, idx) => (
              <Col key={idx} className="border-end last-child-border-0 text-center">
                <div className="text-muted fs-11 mb-2">{item.label}</div>
                <div className="fw-bold text-black fs-13 transition-all">
                  {item.value}
                </div>
              </Col>
            ))}
          </Row>
        </div>

        <div className="d-flex justify-content-end gap-2 mb-3">
          <Badge
            bg="light"
            className="text-black border px-3 py-2 d-flex align-items-center"
            style={{
              borderRadius: "20px",
              fontSize: "12px",
              backgroundColor: "#F1F5F9",
              borderColor: "#E2E8F0",
              height: "40px",
            }}
          >
            <span className="text-muted me-2">Total cash:</span>
            <span className="fw-bold" style={{ color: "#1E40AF" }}>
              SGD 111,419
            </span>
          </Badge>
          <Badge
            bg="light"
            className="text-black border px-3 py-2 d-flex align-items-center"
            style={{
              borderRadius: "20px",
              fontSize: "12px",
              backgroundColor: "#F1F5F9",
              borderColor: "#E2E8F0",
              height: "40px",
            }}
          >
            <span className="text-muted me-2">Total Request:</span>
            <span className="fw-bold" style={{ color: "#1E40AF" }}>
              SGD {request.amount}
            </span>
          </Badge>
        </div>

        <div className="card shadow-none rounded-4 overflow-hidden border border-light">
          <DataTable
            columns={columns}
            data={denominations}
            showPagination={false}
            minWidth="100%"
          />
        </div>
      </div>
    </CommonModal>
  );
};

export default RequestInformationModal;
